export default __webpack_public_path__ + "static/media/Renato_Bagarolo_Italy.7d84cd10.png";